import type { Translate } from '@client-app/i18n';

export const getIntegrationConnectionLabelPlaceholder = (
    t: Translate,
    toolName: string,
): string => (
    toolName === 'Shopify'
        ? t('website.integrationsSettings.shopifyLabelPlaceholder')
        : t('website.integrationsSettings.genericToolLabelPlaceholder', { tool: toolName })
);
